(() => {
  'use strict';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const clamp = (v, min = 0, max = 1) => Math.min(max, Math.max(min, v));
  const range = (v, a, b) => clamp((v - a) / (b - a));
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 760px), (max-width: 1024px) and (pointer: coarse)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  let userMotionOff = false;
  try { userMotionOff = localStorage.getItem('lwk-motion') === 'off'; } catch {}
  const cinema = $('[data-cinema]');
  const blueprint = $('[data-blueprint]');
  const canvas = $('.scene-canvas');
  const context = canvas?.getContext('2d', { alpha: false });
  const poster = $('.hero-poster');
  const frames = new Map();
  let loadStarted = false, raf = 0, currentFrame = -1, heroProgress = 0, pageProgress = 0;
  let lastWidth = 0, lastHeight = 0, pointerX = 65, pointerY = 45;
  let pointerVisible = false;
  const debug = $('.motion-debug');
  if (new URLSearchParams(location.search).has('motion-debug') && debug) debug.hidden = false;
  const motionAllowed = () => !reduced.matches && !userMotionOff && !mobile.matches && cinema?.dataset.enabled !== 'false';
  const normalized = section => {
    if (!section) return 0;
    const rect = section.getBoundingClientRect();
    return clamp(-rect.top / Math.max(1, section.offsetHeight - innerHeight));
  };
  function drawFrame(index) {
    if (!canvas || !context || !frames.size) return;
    let found = frames.get(index);
    let chosen = index;
    if (!found) {
      let distance = Infinity;
      for (const [i, img] of frames) if (Math.abs(i - index) < distance) { chosen = i; found = img; distance = Math.abs(i - index); }
    }
    if (!found || !found.naturalWidth) return;
    const width = Math.round(Math.min(innerWidth, 1600));
    const height = Math.round(width * canvas.clientHeight / Math.max(canvas.clientWidth, 1));
    if (width !== lastWidth || height !== lastHeight) { canvas.width = width; canvas.height = height; lastWidth = width; lastHeight = height; currentFrame = -1; }
    if (chosen === currentFrame) return;
    const scale = Math.max(width / found.naturalWidth, height / found.naturalHeight);
    const w = found.naturalWidth * scale, h = found.naturalHeight * scale;
    context.drawImage(found, (width-w)/2, (height-h)/2, w, h);
    currentFrame = chosen;
    canvas.classList.add('ready');
  }
  async function loadFrames() {
    if (!canvas || loadStarted || !motionAllowed()) return;
    loadStarted = true;
    const total = Number(canvas.dataset.frameCount);
    const coarse = Array.from({ length: Math.ceil(total / 6) }, (_, i) => i * 6);
    const queue = [...coarse, ...Array.from({ length: total }, (_, i) => i).filter(i => !coarse.includes(i))];
    const prefix = canvas.dataset.framePrefix;
    const worker = async () => {
      while (queue.length) {
        if (!motionAllowed()) break;
        const i = queue.shift();
        await new Promise(resolve => {
          const img = new Image();
          img.decoding = 'async';
          img.onload = () => { frames.set(i, img); schedule(); resolve(); };
          img.onerror = resolve;
          img.src = prefix.replace('000', String(i).padStart(3, '0'));
        });
      }
    };
    await Promise.all([worker(), worker(), worker(), worker()]);
    loadStarted = frames.size >= total;
  }
  function render() {
    raf = 0;
    // Mobile has its own cached geometry and portrait media.
    if (mobile.matches) return;
    const active = motionAllowed();
    heroProgress = normalized(cinema);
    pageProgress = normalized(blueprint);
    if (cinema && active) {
      const p = heroProgress;
      const opening = $('.hero-opening', cinema);
      const openingOut = range(p, .035, .25);
      opening.style.opacity = String(1 - openingOut);
      opening.style.transform = `translate3d(${-openingOut*90}px,${-openingOut*25}px,0) scale(${1+openingOut*.18})`;
      const interlude = $('.hero-interlude', cinema);
      interlude.style.opacity = String(range(p,.27,.37) * (1-range(p,.52,.66)));
      interlude.style.transform = `scale(${1+range(p,.27,.65)*.22})`;
      const arrival = $('.hero-arrival', cinema);
      const arrivalIn = range(p,.77,.94);
      arrival.style.opacity = String(arrivalIn);
      arrival.style.transform = `translateY(${(1-arrivalIn)*35}px)`;
      arrival.inert = p < .85;
      $('.cinema-progress>span', cinema).style.transform = `scaleX(${p})`;
      const index = Math.round(range(p,.055,.9) * (Number(canvas.dataset.frameCount)-1));
      drawFrame(index);
      const cue = $('.scroll-cue', cinema);
      cue.style.opacity = String(1 - range(p, .015, .12));
      cue.inert = p >= .12;
      $('.scene-shade', cinema).style.backgroundColor = `rgba(7,12,7,${arrivalIn*.25})`;
      cinema.style.setProperty('--pointer-x', `${pointerX}%`);
      cinema.style.setProperty('--pointer-y', `${pointerY}%`);
      cinema.classList.toggle('pointer-active', pointerVisible && fine.matches);
    } else if (cinema) {
      cinema.classList.remove('pointer-active');
      $('.hero-arrival', cinema).inert = true;
    }
    if (blueprint && active && innerHeight >= 740) {
      const p = pageProgress;
      const fan = range(p,.05,.62);
      const out = innerWidth * .235 * fan;
      const paperFront=$('.paper-front',blueprint);
      if (paperFront) paperFront.style.transform = `translate(calc(-50% - ${out}px),-50%) rotate(${-8 + fan*3}deg) rotateY(${-fan*12}deg)`;
      const paperMiddle=$('.paper-middle',blueprint);
      if (paperMiddle) paperMiddle.style.transform = `translate(-50%,${-50-fan*3}%) rotate(${2*(1-fan)}deg) scale(${1+fan*.06})`;
      const paperBack=$('.paper-back',blueprint);
      if (paperBack) paperBack.style.transform = `translate(calc(-50% + ${out}px),-50%) rotate(${12-fan*7}deg) rotateY(${fan*12}deg)`;
      const durationMark=$('.large-eight',blueprint);
      if (durationMark) durationMark.style.transform = `translate(-50%,-50%) scale(${.8+fan*.4})`;
      const phaseLine=$('.phase-line>span',blueprint);
      if (phaseLine) phaseLine.style.transform = `scaleX(${.04+range(p,.15,.95)*.96})`;
      $$('.phase',blueprint).forEach((phase,i)=>phase.classList.toggle('active',p >= i*.24));
    }
    if (debug && !debug.hidden) debug.textContent = `LWK / THE PRACTICE\nScene: ${(heroProgress*100).toFixed(1)}% · frame ${currentFrame+1}/90\nUnfold: ${(pageProgress*100).toFixed(1)}%\nPointer: ${pointerVisible ? `${pointerX.toFixed(0)},${pointerY.toFixed(0)}`:'inactive'}\nMotion: ${active?'on':'static'} · loaded ${frames.size}/90`;
    window.lwkMotion = { heroProgress, pageProgress, currentFrame, loadedFrames: frames.size, pointerVisible: pointerVisible && active && fine.matches, motionAllowed: active };
  }
  function schedule() { if (!raf) raf = requestAnimationFrame(render); }
  function setMotionMode() {
    window.lwkMotionPreferences={osReduced:reduced.matches,site:userMotionOff?'off':'on/default',effective:reduced.matches||userMotionOff?'reduced':'normal'};
    document.documentElement.classList.toggle('static-motion', reduced.matches || userMotionOff || cinema?.dataset.enabled === 'false');
    document.dispatchEvent(new CustomEvent('lwk:motionchange'));
    $$('.motion-toggle').forEach(button => {
      const off = reduced.matches || userMotionOff;
      button.setAttribute('aria-pressed', String(off));
      // The OS preference takes precedence; do not silently change a saved preference underneath it.
      button.disabled=reduced.matches;
      $('span',button).textContent = off ? button.dataset.off : button.dataset.on;
    });
    if(!mobile.matches && blueprint) $$('img[data-src]',blueprint).forEach(img=>{if(!img.getAttribute('src'))img.src=img.dataset.src;});
    if (motionAllowed()) loadFrames();
    schedule();
    if (reduced.matches || userMotionOff) videoManuallyStarted = false;
    updateVideoPlayback();
  }
  addEventListener('scroll', schedule, { passive:true });
  addEventListener('resize', schedule, { passive:true });
  [reduced,mobile,fine].forEach(query=>query.addEventListener('change',setMotionMode));
  cinema?.addEventListener('pointermove', event=>{
    if (!motionAllowed() || !fine.matches || event.pointerType==='touch') return;
    const rect=$('.cinema-stage',cinema).getBoundingClientRect();
    pointerX=clamp((event.clientX-rect.left)/rect.width*100,8,95);
    pointerY=clamp((event.clientY-rect.top)/rect.height*100,8,95);
    pointerVisible=true;schedule();
  },{passive:true});
  cinema?.addEventListener('pointerleave',()=>{pointerVisible=false;schedule();});
  $$('.motion-toggle').forEach(button=>button.addEventListener('click',()=>{
    userMotionOff=!userMotionOff;
    try { localStorage.setItem('lwk-motion', userMotionOff?'off':'on'); } catch {}
    setMotionMode();
  }));
  addEventListener('storage',event=>{if(event.key==='lwk-motion'||event.key===null){userMotionOff=event.newValue==='off';setMotionMode();}});
  // All commercial UI works without the cinematic scene.
  const menuButton=$('.menu-toggle'), menu=$('#mobile-menu');
  function closeMenu() { if(!menu)return;menu.hidden=true;menuButton?.setAttribute('aria-expanded','false'); }
  menuButton?.addEventListener('click',()=>{const open=menuButton.getAttribute('aria-expanded')!=='true';menu.hidden=!open;menuButton.setAttribute('aria-expanded',String(open));});
  $$('a',menu || document.createElement('div')).forEach(a=>a.addEventListener('click',closeMenu));
  document.addEventListener('keydown',event=>{if(event.key==='Escape' && menu && !menu.hidden){closeMenu();menuButton.focus();}});
  mobile.addEventListener('change',closeMenu);
  const filterButtons=$$('[data-filter]');
  function filterCatalog(name) {
    filterButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.filter===name)));
    let count=0;
    $$('[data-category]').forEach(card=>{card.hidden=name!=='all'&&card.dataset.category!==name;if(!card.hidden)count++;});
    const selected=filterButtons.find(button=>button.dataset.filter===name);
    const empty=$('[data-empty]');
    if(empty){
      empty.hidden=count>0;
      if(!count){
        $('[data-empty-label]',empty).textContent=selected?.dataset.label || selected?.textContent.trim() || '';
        $('[data-empty-body]',empty).textContent=selected?.dataset.emptyBody || '';
      }
    }
    const status=$('[data-catalog-status]');
    if(status){status.dataset.original ||= status.textContent;status.textContent=name==='all'?status.dataset.original:(selected?.dataset.status || selected?.textContent.trim() || '');}
  }
  filterButtons.forEach(button=>button.addEventListener('click',()=>filterCatalog(button.dataset.filter)));
  $('[data-reset-filter]')?.addEventListener('click',()=>{filterCatalog('all');filterButtons[0]?.focus();});
  const dialog=$('#page-dialog');
  let dialogOpener = null;
  $('.skip-link')?.addEventListener('click',()=>requestAnimationFrame(()=>$('#main')?.focus({preventScroll:true})));
  $$('[data-open-page]').forEach(button=>button.addEventListener('click',()=>{
    if(!dialog)return;
    dialogOpener=button;
    $('img',dialog).src=button.dataset.openPage;
    $('img',dialog).alt=$('img',button)?.alt || button.getAttribute('aria-label') || '';
    dialog.showModal();
  }));
  $('[data-close-dialog]')?.addEventListener('click',()=>dialog.close());
  dialog?.addEventListener('close',()=>dialogOpener?.focus({preventScroll:true}));
  dialog?.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
  const video=$('.free-film video'), play=$('[data-play-video]');
  const desktopVideoSource=video?.dataset.desktopSrc;
  let videoInView=false, videoUserPaused=false, videoManuallyStarted=false, videoFailed=false, videoPending=false;
  let videoAttempts=0, videoResult='not attempted', videoBlocked=false;
  const videoWanted=()=>videoInView && !document.hidden && !videoUserPaused && (!(reduced.matches || userMotionOff) || videoManuallyStarted);
  function prepareVideo(){
    if(!video)return;
    const src=mobile.matches?video.dataset.mobileSrc:desktopVideoSource;
    video.poster=mobile.matches?video.dataset.mobilePoster:video.dataset.desktopPoster;
    if(video.getAttribute('src')!==src){video.src=src;video.load();}
  }
  function syncVideo() {
    if(!video||!play)return;
    play.setAttribute('aria-label',video.paused?play.dataset.play:play.dataset.pause);
    play.dataset.playing=String(!video.paused);
    video.closest('.free-film').classList.toggle('is-playing',!video.paused);
    window.lwkVideo={inView:videoInView,userPaused:videoUserPaused,attempts:videoAttempts,result:videoResult,status:videoFailed?'media failed':!video.paused?'playing':videoUserPaused?'user pause':!videoInView||document.hidden?'visibility pause':(reduced.matches||userMotionOff)&&!videoManuallyStarted?'motion preference pause':'paused'};
  }
  function videoUnavailable(){
    if(!video||!play)return;
    videoFailed=true;
    video.pause();
    play.disabled=true;
    video.closest('.free-film').classList.remove('is-playing');
    if(!$('.video-error-note',video.parentElement)){
      const note=document.createElement('p');note.className='video-error-note';note.setAttribute('role','status');note.textContent=play.dataset.error;video.parentElement.append(note);
    }
  }
  async function startVideo(){
    if(videoPending || videoFailed)return;
    videoPending=true;videoAttempts++;videoResult='attempting muted inline play';syncVideo();
    prepareVideo();
    try { await video.play();videoResult='play succeeded'; }
    catch(error) {
      videoResult=`${error.name}: ${error.message}`;
      videoBlocked=error.name==='NotAllowedError';
      // An autoplay restriction is recoverable with the existing Play button.
      if(error.name!=='NotAllowedError' && error.name!=='AbortError') videoUnavailable();
    }
    finally {videoPending=false;}
    if(!videoWanted())video.pause();
    syncVideo();
  }
  function updateVideoPlayback(){
    if(!video || videoFailed)return;
    // A saved/OS motion preference is explicit; touch and power are never inferred.
    video.autoplay=!(reduced.matches||userMotionOff)||videoManuallyStarted;
    if(!videoWanted()){video.pause();syncVideo();return;}
    if(video.paused&&!videoBlocked)startVideo();
    syncVideo();
  }
  play?.addEventListener('click',()=>{
    if(video.paused){videoUserPaused=false;videoManuallyStarted=true;videoBlocked=false;video.autoplay=true;startVideo();}
    else {videoUserPaused=true;videoManuallyStarted=false;video.pause();}
    syncVideo();
  });
  video?.addEventListener('error',videoUnavailable);
  if(video)$$('source',video).forEach(source=>source.addEventListener('error',videoUnavailable));
  if(video){
    // Set properties before assigning any media URL; markup also carries these attributes.
    video.defaultMuted=true;video.muted=true;video.playsInline=true;video.loop=true;
    video.autoplay=!(reduced.matches||userMotionOff);
    video.poster=mobile.matches?video.dataset.mobilePoster:video.dataset.desktopPoster;
    video.addEventListener('pause',syncVideo);
    video.addEventListener('play',()=>{if(!videoWanted())video.pause();syncVideo();});
    const visibility=visible=>{if(visible!==videoInView)videoBlocked=false;videoInView=visible;updateVideoPlayback();};
    if('IntersectionObserver' in window)new IntersectionObserver(entries=>visibility(entries[0].isIntersecting&&entries[0].intersectionRatio>=.15),{threshold:[0,.15]}).observe(video);
    else {
      let videoRaf=0;
      const visible=()=>{if(videoRaf)return;videoRaf=requestAnimationFrame(()=>{videoRaf=0;const r=video.getBoundingClientRect();visibility(Math.min(r.bottom,innerHeight)-Math.max(r.top,0)>=r.height*.15);});};
      addEventListener('scroll',visible,{passive:true});addEventListener('resize',visible,{passive:true});visible();
    }
  }
  mobile.addEventListener('change',()=>{
    if(!video)return;
    video.pause();video.removeAttribute('src');
    video.poster=mobile.matches?video.dataset.mobilePoster:video.dataset.desktopPoster;
    videoBlocked=false;video.load();updateVideoPlayback();
  });
  setMotionMode();
  document.addEventListener('visibilitychange',updateVideoPlayback);
})();
